import { Modal, Select, Image, Row, Col, Form, Flex, Typography } from "antd";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { setIdEmpresaPermissao, setTitle } from "../../../../redux/slices/configuracoes/configuracoesSlice";
import { BuscaConsignatarioModel } from "../../../../models/consignatario/chamadas/buscaConsignatarioModel";
import { atualizarConsignatarioAtivo, buscarConsignatario, deletarConsignatario, sincronizarConsignatario } from "../../../../services/consiganatarioService";
import { buscarEmpresa } from "../../../../services/empresaService";
import { listarEstado } from "../../../../services/localizacaoService";
import {
  setBuscaConsignatario,
  setEntityConsignatario,
  setModalDadosUsuarioConsignatario,
  setModalDeletarConsignatario,
  setPageConsignatario,
} from "../../../../redux/slices/consignatario/consignatarioSlice";
import { ConsignatarioModel } from "../../../../models/consignatario/consignatarioModel";
import { AtualizarConsignatarioAtivoModel } from "../../../../models/consignatario/chamadas/atualizarConsignatarioAtivoModel";
import { ItemMenuAcoes } from "../../../../models/sistema/itemMenuAcoes";
import * as Icon from "@ant-design/icons";
import { ColumnsType } from "antd/lib/table";
import { formatCPFCNPJ } from "../../../../util/formats";
import AcoesComponent from "../../../../components/table/acoesComponent";
import { EmpresaModel } from "../../../../models/empresa/empresaModel";
import Search from "antd/es/input/Search";
import TableComponent from "../../../../components/table/tableComponent";
import DadosUsuarioModal from "../../modals/dadosUsuario";
import MensagemModal from "../../../../components/modal/mensagem";
import { ButtonComponent } from "../../../../components/button/cadastrar";
import { SwitchComponent } from "../../../../components/button/switch";
import { DeletarConsignatarioModel } from "../../../../models/consignatario/chamadas/deletarConsignatarioModel";

const GeralPage = () => {
  //estados globais
  const consignatarioState = useAppSelector((state) => state.consignatario);
  const localizacaoState = useAppSelector((state) => state.localizacao);
  const empresaState = useAppSelector((state) => state.empresa);
  const persistedState = useAppSelector((state) => state.persisted);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();

  useEffect(() => {
    dispatch(setTitle("CONSIGNATÁRIOS"));
    dispatch(buscarEmpresa(empresaState.busca));
    dispatch(listarEstado());
    if (persistedState.user.empresa !== null) {
      let args: BuscaConsignatarioModel = { ...consignatarioState.busca, idEmpresa: persistedState.user.empresa.idEmpresa };
      dispatch(buscarConsignatario(args));
      form.setFieldsValue({ idEmpresa: persistedState.user.empresa.idEmpresa, pesquisar: consignatarioState.busca.pesquisar });
    } else {
      if (consignatarioState.busca.idEmpresa) {
        onChangeEmpresa(consignatarioState.busca.idEmpresa);
      }
      form.setFieldsValue({ idEmpresa: consignatarioState.busca.idEmpresa, pesquisar: consignatarioState.busca.pesquisar });
    }
  }, []);

  const sincronizar = (values: any) => {
    dispatch(sincronizarConsignatario({ value: values.idEmpresa, busca: consignatarioState.busca }));
  };

  const goEditar = (value: ConsignatarioModel) => {
    dispatch(setEntityConsignatario(value));
    dispatch(setPageConsignatario("cadastrar"));
  };

  const goDeletar = (value: ConsignatarioModel) => {
    dispatch(setEntityConsignatario(value));
    dispatch(setModalDeletarConsignatario(true));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarConsignatario(false));
  };

  const goDadosUsuario = (value: ConsignatarioModel) => {
    dispatch(setEntityConsignatario(value));
    dispatch(setModalDadosUsuarioConsignatario(true));
  };

  const closeModalDadosUsuario = () => {
    dispatch(setModalDadosUsuarioConsignatario(false));
  };

  const changeAtivo = (value: ConsignatarioModel) => {
    let args: AtualizarConsignatarioAtivoModel = {
      idPessoa: value.idPessoa,
      ativo: !value.ativo,
    };
    dispatch(atualizarConsignatarioAtivo({ value: args, busca: consignatarioState.busca }));
  };

  const onSearch = (value: string) => {
    let args: BuscaConsignatarioModel = { ...consignatarioState.busca, pesquisar: value };

    dispatch(setBuscaConsignatario(args));
    dispatch(buscarConsignatario(args));
  };

  const onChangeEmpresa = (value: number) => {
    dispatch(setIdEmpresaPermissao(value));

    let args: BuscaConsignatarioModel = { ...consignatarioState.busca, idEmpresa: value };

    dispatch(setBuscaConsignatario(args));
    dispatch(buscarConsignatario(args));
  };

  const filtroEmpresa = () =>
    Array.from(
      new Set<any>(
        empresaState.list.map((a: any) => ({
          text: a.apelido,
          value: a.id,
        }))
      )
    );

  const items: ItemMenuAcoes[] = [
    {
      label: "Editar",
      key: "1",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Gerar dados usuário",
      key: "2",
      icon: <Icon.UserOutlined />,
      function: (item: any) => goDadosUsuario(item),
      disabled: (item: any) => item.idUsuario !== null,
    },
    {
      label: "Remover",
      key: "3",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item),
    },
  ];

  const columns: ColumnsType<ConsignatarioModel> = [
    {
      title: "APELIDO",
      dataIndex: "apelido",
      sorter: (a, b) => a.apelido.localeCompare(b.apelido),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "RAZÃO SOCIAL",
      dataIndex: "razaoSocial",
      sorter: (a, b) => a.razaoSocial.localeCompare(b.razaoSocial),
      sortDirections: ["ascend", "descend", "ascend"],
      render: (_, record) => (
        <Typography.Text style={{ width: 300 }} ellipsis={{ tooltip: record.razaoSocial }}>
          {record.razaoSocial}
        </Typography.Text>
      ),
    },
    {
      title: "CPF/CNPJ",
      dataIndex: "cpfcnpj",
      render: (_, record) => formatCPFCNPJ(record.cpfcnpj),
    },
    {
      title: "EMPRESA",
      dataIndex: "idEmpresa",
      filters: filtroEmpresa(),
      onFilter: (value: any, record: any) => record.idEmpresa === value,
      render: (_, record) => {
        return <>{empresaState.list.find((a: any) => a.id === record.idEmpresa)?.apelido}</>;
      },
    },
    {
      title: "CIDADE",
      dataIndex: "cidade",
      sorter: (a: any, b: any) => a.cidade?.localeCompare(b.cidade),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "ESTADO",
      dataIndex: "idEstado",
      render: (_, record) => {
        return <>{localizacaoState.listEstado.find((a: any) => a.id === record.idEstado)?.denominacao}</>;
      },
    },
    {
      title: "ATIVO",
      dataIndex: "ativo",
      width: 100,
      filters: [
        {
          text: "Ativo",
          value: "true" as any,
        },
        {
          text: "Inativo",
          value: "false" as any,
        },
      ],
      onFilter: (value: any, record: any) => record.ativo.toString().includes(value),
      defaultFilteredValue: ["true" as any],
      render: (_, record) => <SwitchComponent checked={record.ativo} onChange={() => changeAtivo(record)} />,
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      render: (_, record) => <AcoesComponent record={record} items={items} />,
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical" form={form} onFinish={sincronizar}>
        <Row gutter={12} align="bottom">
          <Col span={20}>
            <Flex gap={12}>
              {persistedState.user.empresa === null && (
                <Form.Item label="Empresa" name="idEmpresa" rules={[{ required: true, message: "Campo obrigatório" }]}>
                  <Select
                    showSearch
                    optionFilterProp="labelSearch"
                    loading={empresaState.loading}
                    onChange={onChangeEmpresa}
                    style={{ width: 300 }}
                    options={empresaState.list.map((a: EmpresaModel) => ({
                      value: a.id,
                      key: a.apelido,
                      label: (
                        <Flex justify="flex-start" align="center" gap={8} style={{ padding: "1px 0px" }}>
                          <Flex style={{ lineHeight: "0px" }}>{a.urlLogotipoPequeno && <Image width={25} height={25} style={{ lineHeight: "0px" }} src={a.urlLogotipoPequeno} preview={false} />}</Flex>
                          {a.apelido}
                        </Flex>
                      ),
                      labelSearch: a.apelido,
                    }))}
                  />
                </Form.Item>
              )}
              <Form.Item label="Pesquisar" name="pesquisar">
                <Search allowClear style={{ width: 300 }} disabled={consignatarioState.loading} placeholder="Apelido" onSearch={onSearch} className="searchInput" enterButton />
              </Form.Item>
            </Flex>
          </Col>
          <Col span={4}>
            <Flex justify="end">
              <ButtonComponent htmlType="submit">SINCRONIZAR CONSIGNATÁRIOS</ButtonComponent>
            </Flex>
          </Col>
        </Row>
      </Form>
      <TableComponent data={consignatarioState.list} columns={columns} loading={consignatarioState.loading} />
      <Modal title={"DADOS USUÁRIO"} centered width={900} open={consignatarioState.modalDadosUsuario} onCancel={closeModalDadosUsuario} footer={null} destroyOnHidden>
        <DadosUsuarioModal />
      </Modal>
      <Modal title={"REMOVER CONSIGNATÁRIO"} centered width={350} open={consignatarioState.modalDeletar} onCancel={closeModalDeletar} footer={null} destroyOnHidden>
        <MensagemModal
          text="Deseja remover o consignatário?"
          action={deletarConsignatario({
            value: {
              id: consignatarioState.entity.id,
              idPessoa: consignatarioState.entity.idPessoa,
              idUsuario: consignatarioState.entity.idUsuario,
            } as DeletarConsignatarioModel,
            busca: consignatarioState.busca,
          })}
          close={setModalDeletarConsignatario(false)}
        />
      </Modal>
    </Flex>
  );
};

export default GeralPage;
